import { t } from 'lib/translations/i18next'
import { logError } from 'lib/tracking/datadog'
import { StepEnum } from 'gql/types'

export const getLabelByStep = (type: StepEnum) => {
  switch (type) {
    case StepEnum.CONNECT_SHOPIFY:
      return t('payerOnboardingStepper::connectShopify')
    case StepEnum.SET_BASELINE_COSTS:
      return t('payerOnboardingStepper::setBaselineCosts')
    case StepEnum.UPLOAD_CSV:
      return t('payerOnboardingStepper::setBaselineCosts')
    case StepEnum.SYNC_LANDED_COSTS:
      return t('payerOnboardingStepper::syncLandedCosts')

    default: {
      logError(new Error('Missing copy for onboarding step'))

      return type
    }
  }
}
